var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClick},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('span',{staticClass:"external-button"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('i',{staticClass:"material-symbols-rounded icon_externalLink"},[_vm._v("open_in_new")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }